import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

export default function FizLico() {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTariff, setActiveTariff] = useState(null); 
  // Общие стили
  const containerStyle = {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '30px',
  };

  const cardsContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '20px',
  };

  // Стиль карточки
  const cardStyle = {
    border: '1px solid #ccc',
    borderRadius: '12px',
    padding: '20px',
    width: '300px',
    minHeight: '450px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s, box-shadow 0.3s',
  };

  const cardHoverStyle = {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
  };

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const buttonStyle = {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '20px',
    transition: 'background-color 0.3s, transform 0.3s',
    marginTop: 'auto',
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
    transform: 'scale(1.05)',
  };

  const tariffs = [
    {
      title: 'Оптика в квартиру',
      speed1: '50 Мбит/с',
      price1: '500 Р/мес',
      speed2: '100 Мбит/с',
      price2: '700 Р/мес',
      speed3: '200 Мбит/с',
      price3: '900 Р/мес',
      speed4: '300 Мбит/с',
      price4: '1100 Р/мес',
    },
    {
      title: 'Городской',
      speed1: '30 Мбит/с',
      price1: '605 Р/мес',
      speed2: '60 Мбит/с',
      price2: '715 Р/мес',
      speed3: '100 Мбит/с',
      price3: '825 Р/мес',
      speed4: '',
      price4: '',
    },
  ];

  const openModal = (tariff) => {
    setActiveTariff(tariff);
    setModalOpen(true);

  };

  const closeModal = () => {
    setModalOpen(false);
    setActiveTariff(null);
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalStyle = {
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '10px',
    maxWidth: '400px',
    width: '90%',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    position: 'relative',
  };

  return (
    <React.Fragment>
      <Meta
         title="Домашний интернет  — выгодные тарифы в Подольске и Московской области"
         description="Предлагаем выгодные и качественные интернет-пакеты для физических лиц с быстрым подключением в Московской области (Подольск, Быковка, Александровка, Чулпаново, Кучино, Домодедово, Видное, Северово, Стрелково, Остафьево, Щербинка, Знамя Октября, Старосырово, Борисовка и т.д.)"
       />
    <div style={containerStyle}>
      <h1 style={headerStyle}>Домашний интернет: тарифы и цены для физических лиц</h1>

      <div style={cardsContainerStyle}>
        {tariffs.map((tariff, index) => (
          <div
            key={index}
            style={{
              ...cardStyle,
              ...(hoveredIndex === index ? cardHoverStyle : {}),
            }}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <h2 style={{ marginBottom: '10px', textAlign: 'center' }}>{tariff.title}</h2>
            {[
              { speed: tariff.speed1, price: tariff.price1 },
              { speed: tariff.speed2, price: tariff.price2 },
              { speed: tariff.speed3, price: tariff.price3 },
              { speed: tariff.speed4, price: tariff.price4 },
            ].map(
              (item, idx) =>
                item.speed && item.price && (
                  <div key={idx} style={{ marginBottom: '10px', width: '100%' }}>
                    <h3 style={{ color: '#007bff', marginBottom: '5px', textAlign: 'center' }}>{item.speed}</h3>
                    <p
                      style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        margin: 0,
                        textAlign: 'center',
                      }}
                    >
                      {item.price}
                    </p>
                  </div>
                )
            )}
            {/* <button
              style={{
                ...buttonStyle,
                ...(hoveredIndex === index ? buttonHoverStyle : {}),
              }}
              onClick={() => openModal(tariff)}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#0056b3')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#007bff')}
            >
              Подключить
            </button> */}
          </div>
        ))}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
  style={{
    position: 'absolute',
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    cursor: 'pointer',
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
    color: '#333',
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '32px',
    textAlign: 'center',
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
    userSelect: 'none',
  }}
  onClick={closeModal}
  aria-label="Закрыть"
  onMouseEnter={e => {
    e.currentTarget.style.backgroundColor = '#e0e0e0';
    e.currentTarget.style.color = '#000';
    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
  }}
  onMouseLeave={e => {
    e.currentTarget.style.backgroundColor = '#f0f0f0';
    e.currentTarget.style.color = '#333';
    e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
  }}
  onMouseDown={e => {
    e.currentTarget.style.backgroundColor = '#d0d0d0';
    e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
  }}
  onMouseUp={e => {
    e.currentTarget.style.backgroundColor = '#e0e0e0';
    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
  }}
>
  ×
</div>

      {/* <h3>Подключение тарифа: {activeTariff.title}</h3>
            <ContactForm /> */}
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}
